import compose from "enhancers/compose";
import { setNestedObjectValues, withFormik } from "formik";
import { withStateHandlers } from "recompose";

const withStateFormik = (config) =>
  compose(
    withStateHandlers(
      {},
      {
        setPropsToFormikBag: (formikBagProps) => (props) => ({
          ...formikBagProps,
          ...props,
        }),
        setInitialValues: (props) => (initialValues) => ({
          ...props,
          __initialValues__: initialValues,
        }),
      }
    ),
    withFormik({
      mapPropsToValues: (props) => {
        if (props.__initialValues__) {
          return props.__initialValues__;
        }
        return {};
      },
      enableReinitialize: true,
      validateOnMount: true,
      validateOnChange: true,
      ...config,
      handleSubmit: async (values, formikBag) => {
        const {
          handleSubmit,
          enablePreventLeaveDirtyForm,
          disablePreventLeaveDirtyForm,
        } = formikBag.props;

        if (!handleSubmit) return;

        const isPreventLeaveActive = !!(
          enablePreventLeaveDirtyForm && disablePreventLeaveDirtyForm
        );

        if (isPreventLeaveActive) disablePreventLeaveDirtyForm();
        try {
          // A page's handleSubmit can resolve normally even when it didn't
          // actually save anything yet (e.g. it opened a confirm modal and
          // the real save happens later in that modal's onOk). Returning
          // `{ resetForm: false }` lets it opt out of being treated as a
          // successful submit; anything else (including returning nothing)
          // keeps the default behavior of treating a resolved promise as
          // success.
          const { resetForm = true } = (await handleSubmit(values)) ?? {};
          if (isPreventLeaveActive && resetForm) {
            // Keep every field touched (Formik's own SUBMIT_ATTEMPT already
            // marked them all touched) so field-level errors set by the
            // page's handleSubmit after a failed submit still render.
            formikBag.resetForm({
              values,
              touched: setNestedObjectValues(values, true),
            });
          }
        } finally {
          if (isPreventLeaveActive) enablePreventLeaveDirtyForm();
        }
      },
    })
  );

export default withStateFormik;
